import { Controller } from 'stimulus'
import { useDebounce } from 'stimulus-use'

// Page-builder node styles, homed here rather than in a controller of their own. Both used to sit
// behind a Stimulus controller that did nothing BUT import them, mounted per node (and per
// paragraph) — so every node on every rendered page, published ones included, paid for a
// data-controller token, a Scope and an entry in Stimulus's scope map to deliver a stylesheet.
// This controller is mounted exactly once per doc-wrapper, in the same documents (the editor's
// preview iframe and the published page), and the import is module-level, so the CSS still
// arrives with the same lazy chunk and the same timing. Keep them here while the styles are
// page-wide rather than owned by one mounted component.
import './node_component.scss'
import './elements/paragraph_component.scss'

export default class extends Controller {
  static targets = ['input']
  static debounces = ['handleInputVisibility']

  connect() {
    useDebounce(this)

    this.handleInputVisibility()
  }

  handleInputVisibility() {
    this.inputTargets.forEach((input) => {
      if (input.type == 'hidden') return

      if (input.dataset.initialDisabledValue === undefined) {
        input.dataset.initialDisabledValue = input.disabled.toString()
      }

      // Some inputs are always hidden, like the country code field. So instead of checking its
      // visibility, delegate that to another element. For example in the case of country code,
      // we'll check the phone number field
      const visibilityElement = input.dataset.visibilityElementId
        ? document.getElementById(input.dataset.visibilityElementId)
        : input

      const hidden = visibilityElement.offsetParent === null

      if (hidden) {
        input.disabled = true
      } else {
        input.disabled = input.dataset.initialDisabledValue == 'disabled'
      }
    })
  }
}
